import { UserCircleIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import Alert from "../Alert";
import LoadingSpinner from "../LoadingSpinner";
import { useGetPlotQuery } from "/src/redux/plotsApi";

export default function MapEditorPerson({_id, plotId, className}){
    const { data, error: queryError, isLoading } = useGetPlotQuery(plotId, {skip: !plotId});
    const [person, setPerson] = useState(null);

    useEffect(()=>{
        if(data){
            let found;
            if(!found && Array.isArray(data.plotOwners)){
                found = data.plotOwners.find(p=>{
                    return p._id == _id;
                });
            }
            if(!found && Array.isArray(data.plotOccupants)){
                found = data.plotOccupants.find(p=>{
                    return p._id == _id;
                });
            }
            if(found) setPerson(found);
        }else{
            setPerson(null);
        }
    },[data]);

    return (
        <div className={className || ''}>
            {(queryError && (
                <Alert className='border-t-red-600'><p>Failed to load person</p></Alert>
            )) || (isLoading && (
                <Alert><LoadingSpinner className='w-6' /></Alert>
            )) || (person && (
                <div className="flex">
                    <UserCircleIcon className="w-6 mr-2" />
                    {((person.firstName || person.lastName) && (
                        <span>{person.firstName} {person.lastName}{person.suffix && ','} {person.suffix}</span>
                    )) || (
                        <span>Unknown</span>
                    )}
                    <span className="flex-grow"></span>
                    {(person.birthDate || person.deathDate) && <span className="font-light">{person.birthDate || 'XXXX-XX-XX'} &mdash; {person.deathDate || 'XXXX-XX-XX'}</span>}
                </div>
            )) || (
                <p>No Entry</p>
            )}
            
        </div>
    )
}